import axiosIns from '@/libs/axios'
import {getUserData} from '@/auth/utils'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchAbout(ctx, store_id) {
      return new Promise((resolve, reject) => {
        axiosIns.get('/about', {params:store_id})
          .then(response => {
            if (response.data.about) {
              resolve(response)
            } else {
              reject(new Error('没有找到数据'))
            }
          })
          .catch(error => reject(error))
      })
    },
    
    updateAbout(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns.post('/about', data, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then(response => resolve(response))
        .catch(error => reject(error))
      })
    }
  }
}
